<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
<app-header-bar
  id="header"
  [title]="_welcomeMessage"
  [showDate]="false"
  [showClientDetails]="false"
  [showButton]="false"
  [age]="_age"
  [dob]="_dob"
  (routerLinkClick)="routerLinkClicked()"
  *ngIf="_dob != undefined || _dob != null"
/>
<!-- Client Information -->
<div class="dashboard-side-card-container">
  <app-client-information
    id="client-information"
    subtitle=""
    [title]="_clientInformationTitle"
    [urlDisplayText]="_clientInformationDisplayText"
    [url]="_clientInformationUrl"
    [attributes]="_clientInformationAttributes"
    [isVertialOrientation]="true"
  />
</div>
<!-- Sub-Menu -->
<app-sub-menu
  [clientId]="clientId"
  [totalReviews]="_totalReviews"
  [flipHasAccess]="_hasAccess.flipHasAccess"
  [reddiHasAccess]="_hasAccess.reddiHasAccess"
  [slatHasAccess]="_hasAccess.slatHasAccess"
  [showBackButton]="true"
  (navigateBackClick)="previousRoute()"
/>
<div class="client-bigger-container">
  <div class="client-dashboard-container">
    <div class="client-dashboard-top-container">
      <div
        *ngIf="_hasAccess.flipHasAccess"
        class="client-dashboard-flip-details-container"
      >
        <app-primary-card size="full" height="600">
          <div class="client-dashboard-title-container">
            <div id="title" class="client-dashboard-title">
              {{ 'FLI-P' | translate }}
            </div>
            <app-action-toolbar
              [isEdit]="false"
              (editClick)="navigateTo('editFlip')"
              [isFullView]="true"
              (fullViewClick)="navigateTo('fullViewFlip')"
              [isHistory]="true"
              (historyClick)="navigateTo('historyFlip')"
              [isReport]="true"
              (reportClick)="navigateTo('reportFlip')"
              [isNew]="true"
              (newClick)="navigateTo('newFlip')"
            />
          </div>
          <div class="client-dashboard-sub-title-container">
            <div id="flip-sub-title" class="client-dashboard-sub-title">
              {{ 'FLI-P Visualisation' | translate }}
            </div>
          </div>
          <div class="client-dashboard-flip-graph-container">
            <div class="flip-fixed-box">
              <app-flip-dashboard-graph
                [clientId]="clientId"
                [autoRefresh]="_autoRefresh"
              />
            </div>
          </div>
        </app-primary-card>
      </div>
      <div
        *ngIf="_hasAccess.slatHasAccess"
        class="client-dashboard-slat-details-container"
      >
        <app-primary-card size="full" height="600">
          <div class="client-dashboard-title-container">
            <div id="title" class="client-dashboard-title">
              {{ 'SLAT' | translate }}
            </div>
            <app-action-toolbar
              [isEdit]="false"
              (editClick)="navigateTo('editSlat')"
              [isFullView]="false"
              (fullViewClick)="navigateTo('fullViewSlat')"
              [isHistory]="true"
              (historyClick)="navigateTo('historySlat')"
              [isReport]="false"
              (reportClick)="navigateTo('reportSlat')"
              [isNew]="true"
              (newClick)="navigateTo('newSlat')"
            />
          </div>
          <div class="client-dashboard-sub-title-container">
            <div id="reddi-sub-title" class="client-dashboard-sub-title">
              {{ 'SLAT Visualisation' | translate }}
            </div>
          </div>
          <div class="client-dashboard-slat-graph-container">
            <app-slat-graph
              [showLegend]="false"
              [clientId]="clientId"
              [showLimits]="true"
              [visibleFilters]="true"
              [visibleLimits]="true"
              [visibleLegend]="true"
            ></app-slat-graph>
          </div>
        </app-primary-card>
      </div>
    </div>
    <div
      class="client-dashboard-reddi-details-container"
      *ngIf="_hasAccess.reddiHasAccess"
    >
      <app-primary-card size="full">
        <div class="client-dashboard-title-container">
          <div id="title" class="client-dashboard-title">
            {{ 'REDDI' | translate }}
          </div>
          <app-action-toolbar
            [isEdit]="false"
            (editClick)="navigateTo('editReddi')"
            [isFullView]="false"
            (fullViewClick)="navigateTo('fullViewReddi')"
            [isHistory]="true"
            (historyClick)="navigateTo('historyReddi')"
            [isReport]="true"
            (reportClick)="navigateTo('reportReddi')"
            [isNew]="true"
            (newClick)="navigateTo('newReddi')"
          />
        </div>
        <div class="client-dashboard-sub-title-container">
          <div id="reddi-sub-title" class="client-dashboard-sub-title">
            {{ 'REDDI Visualisation' | translate }}
          </div>
        </div>
        <div class="client-dashboard-graph-container">
          <app-reddi-graph [clientId]="clientId" [autoRefresh]="_autoRefresh" />
        </div>
      </app-primary-card>
    </div>
  </div>
</div>
